import { datadogRum } from '@datadog/browser-rum';
import { createGraphQLApiProvider } from '@stitch-fix/graphql-api-provider';
import metaValue from '../../utils/metaValue';
import { sendCount } from '../../utils/sendMetrics';
import buildGraphQLApiCache from './GraphQLApiCache';

export const onError = (error, { metadata }) => {
  const isTimeoutError = error.message.includes('408: Request Timeout');

  if (isTimeoutError) {
    sendCount('graphql_timeout');
  }

  if (isTimeoutError) {
    return;
  }

  datadogRum.addError(error, metadata);
};

const { GraphQLApiProvider } = createGraphQLApiProvider({
  graphqlURI: window.gon.graphql_api_endpoint,
  bearerToken: window.gon.graphql_public_bearer_token,
  shadowGraphqlURI: window.gon.shadow_graphql_api_endpoint,
  name: window.gon.apollo_client_name,
  version: window.gon.apollo_client_version,
  csrfToken: metaValue('csrf-token'),
  useGETForHashedQueries: window.gon.use_get_for_hashed_queries,
  onError,
  cache: buildGraphQLApiCache(),
});

export default GraphQLApiProvider;
